export const HEADER_HEIGHT = '60px'
